import { render, staticRenderFns } from "./ReturnListView.vue?vue&type=template&id=120d7e05&"
import script from "./ReturnListView.vue?vue&type=script&lang=js&"
export * from "./ReturnListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports